export default function buildGetUserFeedbacks({
    apiEndpoint,
    apiTools
}) {
    return async function getUserFeedbacks(args = {}) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/user` 
        })
        
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}